<template>
	<div class="vouchersuccess">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">账户充值</div>
					<div class="contentcard">
						<div style="text-align: center;top: 20%;position: relative;">
							<!-- <p style="font-size: 100px;color: #4b505d;margin: 0;">500</p> -->
							<a-icon type="check-circle" theme="filled" style="font-size: 100px;margin-bottom: 40px;color: limegreen;"/>
							<p style="font-size: 20px;color: rgb(0,0,0);">充值成功</p>
							<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="()=>{this.$router.push('accountpandect')}">返回</a-button>
						</div>
					</div>

				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>


	</div>
</template>

<script>
	export default {

		data() {
			return {
				current: ['voucher'],
				openKeys: ['costcenter'],
			}
		}

	};
</script>

<style>

	.vouchersuccess .contentcard {
		padding: 24px;
		background-color: #fff;
		height: 100%;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?0eae2cf8